import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
	chatIsBlocked: {
		id: 'blockedChat.header',
		defaultMessage: 'Чат заблокирован',
	},
	chatNotAvailable: {
		id: 'blockedChat.chatNotAvailable',
		defaultMessage: 'К сожалению, чат сейчас недоступен. Попробуйте написать позднее.',
	},
	suspiciousActions: {
		id: 'blockedChat.suspiciousActions',
		defaultMessage: 'С Вашего устройства были зарегистрированы подозрительные действия.',
	},
	chatTemporarilyBlocked: {
		id: 'blockedChat.chatTemporarilyBlocked',
		defaultMessage: 'Чат временно заблокирован.',
	},
});
